module.exports = __webpack_public_path__ + "img/07.53aa2009.png";